export interface Theme {
  name: string;
  colors: {
    mainMenuBackground: string;
    subMenuBackground: string;
    selectedMenuItemBG: string;
    subMenuSelectedItemBG: string
    menuText: string;
    contentBackground: string;
    contentText: string;
    placeholder: string;
    white: string;
    topBarsColorBG: string;
    topBarsColorBorder: string;
    topBarsColorText: string;
    topBarsColorHover: string;
    topBarInputText: string;
  },
  CorporateTheme: {
    colors: {
      primary: string,
      builderBg: string,
      lightBlueBg: string,
      lightBlueHeaderBg: string,
      graniteGrey: string,
      redOrange: string,
      lightNavy: string,
      charlestonGreen: string,
      secondary: string,
      accent: string,
      danger: string,
      background: string,
      paraColor: string,
      border: string,
      sweetGrey: string,

      borderOrange: string,
      textPrimary: string,
      textSecondary: string,
      gunmetal: string,
      blueLotus: string,
      ashGrey: string,
      heavyMetal: string,
      count: string,
      melonYellow: string,
      headerColor: string,
      headerBG: string,
      dropZoneBG: string,
      paginationSelect: string,
      labelBG: string,
      filterBG: string,
      bannerBg: string,
      lightSecondary: string,
      panelBG: string,
      link: string,
      whiteBlack: string,
      darkLightBG: string,
      primaryLightBG: string,
      formBuilderDraggingBG: string;
      formBuilderNormalBG: string;
      skelletonBG: string;
      containerShadow: string,
      white: string
      whiteSmoke: string,
      midGrey: string,
      stackBg: string,
      green: string,
      infoBoxBG: string,
      blueberry: string,
      buttonOrange: string,
      redLabel: string,
      mintBG: string,
      lightOrangeBG: string,
      darkContrast: string,
      darkOverlay: string,
      accentOrange: string,
    },
    spacing: {
      xs: string,
      sm: string,
      md: string,
      lg: string,
      xl: string,
    },
    borderRadius: string,
    shadow: string,
    linearGradient: string
  },
  CreateFormTheme: {
    colors: {
      primary: string,
      builderBg: string,
      lightBlueBg: string,
      lightBlueHeaderBg: string,
      graniteGrey: string,
      lightSecondary: string,
      blueberry: string,
      redOrange: string,
      lightNavy: string,
      charlestonGreen: string,
      secondary: string,
      accent: string,
      danger: string,
      background: string,
      border: string,
      sweetGrey: string,
      textPrimary: string,
      textSecondary: string,
      gunmetal: string,
      blueLotus: string,
      ashGrey: string,
      heavyMetal: string,
      count: string,
      melonYellow: string,
      headerColor: string,
      headerBG: string,
      paginationSelect: string,
      labelBG: string,
      filterBG: string,
      required: string,
      inputBorders: string,
      inputBackground: string,
      addressBG: string,
      primaryBtn: string,
      placeHolder: string,
      inputColor: string,
      hoverCancel: string,
      hoverPrimary: string,
      error: string,
      accentOrange: string,
    },
  },
}

export const darkTheme: Theme = {
  name: "dark",
  colors: {
    mainMenuBackground: "#1E1F22",
    subMenuBackground: "#1E1F22",
    selectedMenuItemBG: "rgba(255, 255, 255, 0.1)",
    subMenuSelectedItemBG: "rgba(255, 255, 255, 0.1)",
    menuText: "#FFFFFF",
    contentBackground: "#141414",
    contentText: "#FFFFFF",
    placeholder: "#FFFFFF",
    white: "#ffffff",
    topBarsColorBG: "#1E1F22",
    topBarsColorBorder: "#2E3036",
    topBarsColorText: "#ffffff",
    topBarsColorHover: "rgba(255, 255, 255, 0.1)",
    topBarInputText: "#ffffff",
  },
  CorporateTheme: {
    colors: {
      primary: "#FFFFFF",
      builderBg: '#141414',
      lightBlueBg: "#141414",
      lightBlueHeaderBg: "#141414",
      graniteGrey: "#FFFFFF",
      redOrange: "#EB4335",
      lightNavy: '#ffffff1a',
      charlestonGreen: '#28292E',
      secondary: "#FFFFFF",
      accent: "#FF6D41",
      danger: "#E74C3C",
      background: "#1E1F22",
      paraColor: '#ffffff',
      border: "#2E3036",
      sweetGrey: "#2E3036",
      borderOrange: '',
      textPrimary: "#ffffff",
      textSecondary: "#FFFFFF",
      gunmetal: "#fff",
      blueLotus: "#fff",
      ashGrey: "#fff",
      heavyMetal: "#FFF",
      count: "#FF6D41",
      melonYellow: "#F59E0B",
      headerColor: "#FFFFFF",
      headerBG: "rgba(255, 255, 255, 0.1)",
      dropZoneBG: "rgba(5, 86, 203, 0.40)",
      paginationSelect: "#ffffff",
      labelBG: "rgba(255, 255, 255, 0.1)",
      filterBG: "rgba(255, 255, 255, 0.1)",
      bannerBg: " #1E1F22",
      lightSecondary: '#FFFFFF',
      panelBG: '#1e1f22',
      link: '#0958BC',
      whiteBlack: '#ffffff',
      darkLightBG: '#141414',
      primaryLightBG: 'rgba(255, 255, 255, 0.1)',
      formBuilderDraggingBG: 'rgba(255, 255, 255, 0.1)',
      formBuilderNormalBG: '#141414',
      skelletonBG: '#141414',
      containerShadow: 'linear-gradient(179.92deg, rgba(255, 109, 65, 0.1) 0.07%, rgba(20, 20, 20, 0.1) 9.32%)',
      white: '#ffffff',
      whiteSmoke: "#F3F5F8",
      midGrey: "#626262",
      stackBg: "#636363",
      green: "#ffffff",
      infoBoxBG: "#1E1F22",
      blueberry: "#ffffff",
      buttonOrange: "#343538",
      redLabel: "#ffffff",
      mintBG: "#141414",
      lightOrangeBG: '#FF6D411A',
      darkContrast: '#ffffff',
      darkOverlay: '#1D1D1DCC',
      accentOrange: '#FF6D41',
    },
    spacing: {
      xs: "4px",
      sm: "8px",
      md: "16px",
      lg: "24px",
      xl: "32px",
    },
    borderRadius: "5px",
    shadow: "-4px 4px 40px 0px rgba(255, 255, 255, 0.1)",
    linearGradient: 'linear-gradient(180deg, #2c2c2c 0%, #000000 100%) 1'
  },
  CreateFormTheme: {
    colors: {
      primary: '#ffffff',
      builderBg: '#141414',
      lightBlueBg: '#141414',
      lightBlueHeaderBg: "#141414",
      graniteGrey: "#FFFFFF",
      lightSecondary: "#fff",
      blueberry: '#ffffff',
      redOrange: "#EB4335",
      lightNavy: '#ffffff1a',
      charlestonGreen: '#28292E',
      secondary: '#34495E',
      accent: '#2980B9',
      danger: '#E74C3C',
      background: '#141414',
      border: '#2E3036',
      sweetGrey: "#2E3036",
      textPrimary: '#212529',
      textSecondary: '#FFFFFF',
      gunmetal: '#fff',
      blueLotus: '#fff',
      ashGrey: '#fff',
      heavyMetal: '#FFF',
      count: '#FF6D41',
      melonYellow: "#F59E0B",
      headerColor: '#ffffff',
      headerBG: 'rgba(255, 255, 255, 0.1)',
      paginationSelect: '#636363',
      labelBG: '#F2F2F2',
      filterBG: '#F5F5F5',
      required: '#E74C3C',
      inputBorders: '#676C72',
      inputBackground: '#343538',
      addressBG: '#1e1f22',
      primaryBtn: '#f2f2f2',
      hoverPrimary: '#f2f2f2',
      placeHolder: '#ffffff',
      inputColor: '#ffffff',
      hoverCancel: '#343538',
      error: '#E74C3C',
      accentOrange: '#FF6D41',
    }
  },
};

export const lightTheme: Theme = {
  name: "light",
  colors: {
    mainMenuBackground: "#003366",
    subMenuBackground: "#024383",
    selectedMenuItemBG: "#FFFFFF1A",
    subMenuSelectedItemBG: "#003366",
    menuText: "#FFFFFF",
    contentBackground: "#FFFFFF",
    contentText: "#1E1E1E",
    placeholder: "#748096",
    white: "#FFFFFF",
    topBarsColorBG: "#ffffff",
    topBarsColorBorder: "#0000001a",
    topBarsColorText: "#333",
    topBarsColorHover: "#f5f5f5",
    topBarInputText: "#767476",
  },
  CorporateTheme: {
    colors: {
      primary: "#003366",
      builderBg: '#F5F5F5',
      lightBlueBg: "#f0f7ff",
      lightBlueHeaderBg: "#0556CB0D",
      graniteGrey: "#373F51",
      redOrange: "#EB4335",
      lightNavy: "#024383",
      charlestonGreen: '#fff',
      secondary: "#34495E",
      accent: "#2980B9",
      danger: "#E74C3C",
      background: "#FFFFFF",
      paraColor: '#57595B',
      border: "#EBEAEB",
      sweetGrey: "#DBD6D6",
      borderOrange: '#FF6D4133',
      textPrimary: "#212529",
      textSecondary: "#585558",
      gunmetal: "#292D32",
      blueLotus: "#5575DD",
      ashGrey: "#BCBBBB",
      heavyMetal: '#2A2A2A',
      count: "#FF6D41",
      melonYellow: "#F59E0B",
      headerColor: "#1E1E1E",
      headerBG: "#F5F5F5",
      dropZoneBG: "#0556CB33",
      paginationSelect: "#636363",
      labelBG: "#F2F2F2",
      filterBG: "#F5F5F5",
      bannerBg: " #F3F5F8",
      lightSecondary: '#4A5374',
      panelBG: '#F3F5F899',
      link: '#0958BC',
      whiteBlack: '#000000',
      darkLightBG: '#F5F5F5',
      primaryLightBG: '#0556CB0D',
      formBuilderDraggingBG: '#f0f4ff',
      formBuilderNormalBG: '#f9f9f9',
      skelletonBG: '#e0e0e0',
      containerShadow: 'linear-gradient(179.92deg, rgba(255, 109, 65, 0.1) 0.07%, rgba(255, 255, 255, 0.1) 9.32%)',
      white: '#ffffff',
      whiteSmoke: "#F3F5F8",
      midGrey: "#626262",
      stackBg: "#4A90E2",
      green: "#009828",
      infoBoxBG: "#FFF1C4",
      blueberry: "#0556CB",
      buttonOrange: "#FF6D41",
      redLabel: "#8F0000",
      mintBG: "#e6f7f0",
      lightOrangeBG: '#FF6D411A',
      darkContrast: '#121212',
      darkOverlay: '#1D1D1DCC',
      accentOrange: '#E96618',
    },
    spacing: {
      xs: "4px",
      sm: "8px",
      md: "16px",
      lg: "24px",
      xl: "32px",
    },
    borderRadius: "5px",
    shadow: "-4px 4px 40px 0px rgba(0, 0, 0, 0.1)",
    linearGradient: 'linear-gradient(180deg, #babdc1 0%, #ffffff 100%) 1'
  },
  CreateFormTheme: {
    colors: {
      primary: '#003366',
      builderBg: '#F5F5F5',
      lightBlueBg: '#f0f7ff',
      lightBlueHeaderBg: "#0556CB0D",
      graniteGrey: "#373F51",
      lightSecondary: "#4A5374",
      blueberry: "#0556CB",
      redOrange: "#EB4335",
      lightNavy: "#024383",
      charlestonGreen: '#fff',
      secondary: '#34495E',
      accent: '#2980B9',
      danger: '#E74C3C',
      background: '#FFFFFF',
      border: '#EBEAEB',
      sweetGrey: "#DBD6D6",
      textPrimary: '#212529',
      textSecondary: '#585558',
      gunmetal: '#292D32',
      blueLotus: '#5575DD',
      ashGrey: '#BCBBBB',
      heavyMetal: '#2A2A2A',
      count: '#FF6D41',
      melonYellow: "#F59E0B",
      headerColor: '#1E1E1E',
      headerBG: '#F5F5F5',
      paginationSelect: '#636363',
      labelBG: '#F2F2F2',
      filterBG: '#F5F5F5',
      required: '#E74C3C',
      inputBorders: '#BABDC1',
      inputBackground: '#ffffff',
      addressBG: '#F3F5F899',
      primaryBtn: '#024383',
      hoverPrimary: '#013C75',
      placeHolder: '#748096',
      inputColor: '#767476',
      hoverCancel: '#FAFAFA',
      error: '#E74C3C',
      accentOrange: '#E96618',
    }
  },
};

export const CorporateTheme = {
  colors: {
    primary: "#003366",
    builderBg: '#F5F5F5',
    lightBlueBg: "#f0f7ff",
    lightBlueHeaderBg: "#0556CB0D",
    graniteGrey: "#373F51",
    redOrange: "#EB4335",
    lightNavy: "#024383",
    secondary: "#34495E",
    accent: "#2980B9",
    danger: "#E74C3C",
    background: "#FFFFFF",
    paraColor: '#57595B',
    border: "#EBEAEB",
    sweetGrey: "#DBD6D6",
    textPrimary: "#212529",
    textSecondary: "#585558",
    gunmetal: "#292D32",
    blueLotus: "#5575DD",
    ashGrey: "#BCBBBB",
    heavyMetal: '#2A2A2A',
    count: "#FF6D41",
    headerColor: "#1E1E1E",
    headerBG: "#F5F5F5",
    paginationSelect: "#636363",
    labelBG: "#F2F2F2",
    filterBG: "#F5F5F5",
    bannerBg: " #F3F5F8",
    lightSecondary: '#4A5374',
    panelBG: '#F3F5F899',
    link: '#0958BC',
    white: "#ffffff",
    whiteSmoke: "#F3F5F8",
    midGrey: "#626262",
    blueberry: "#0556CB",
    green: "#009828",
    accentOrange: "#E96618",
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
  },
  borderRadius: "5px",
  shadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  linearGradient: 'linear-gradient(180deg, #babdc1 0%, #ffffff 100%) 1'
};

export const CreateFormTheme = {
  colors: {
    primary: '#003366',
    builderBg: '#F5F5F5',
    lightBlueBg: '#f0f7ff',
    lightBlueHeaderBg: "#0556CB0D",
    graniteGrey: "#373F51",
    lightSecondary: "#4A5374",
    blueberry: "#0556CB",
    redOrange: "#EB4335",
    lightNavy: "#024383",
    secondary: '#34495E',
    accent: '#2980B9',
    danger: '#E74C3C',
    background: '#FFFFFF',
    border: '#EBEAEB',
    sweetGrey: "#DBD6D6",
    textPrimary: '#212529',
    textSecondary: '#585558',
    gunmetal: '#292D32',
    blueLotus: '#5575DD',
    ashGrey: '#BCBBBB',
    heavyMetal: '#2A2A2A',
    count: '#FF6D41',
    headerColor: '#1E1E1E',
    headerBG: '#F5F5F5',
    paginationSelect: '#636363',
    labelBG: '#F2F2F2',
    filterBG: '#F5F5F5',
    required: '#E74C3C',
    inputBorders: '#BABDC1',
    addressBG: '#F3F5F899',
    primaryBtn: '#024383',
    placeHolder: '#748096',
    inputColor: '#767476',
    hoverCancel: '#FAFAFA',
    hoverPrimary: '#013C75',
    error: '#E74C3C',
    accentOrange: '#E96618',
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
  },
  borderRadius: "5px",
  shadow: "-4px 4px 40px 0px rgba(0, 0, 0, 0.1)",
  linearGradient: 'linear-gradient(180deg, #2c2c2c 0%, #000000 100%) 1'
};


type FontType = {
  raleway: string;
  lato: string;
  redHatDisplay: string;
};


export const font: FontType = {
  raleway: 'var(--font-raleway)',
  lato: 'var(--font-lato)',
  redHatDisplay: 'var(--font-red-hat-display)',
};
